import * as Yup from "yup";
import { TStep } from "../types";
import {
  courtOrProtesting,
  indivdualOrganisation,
  methodOfContact,
  tellUsMoreOptions,
} from "./questionOptions";
import { InformationalPopover } from "../../InformationalPopover/InformationalPopover";
import ProtestReview from "../steps/protest/ProtestReview";
export const protestingSteps: {
  [key: string]: TStep;
} = {
  "protesting-step-one": {
    title: "Environmental Protest",
    type: "form",
    note: `Our criminal lawyers can assist you with legal representation, advice and information on laws that regulate environmental protest activities. We can help you with:`,
    components: [
      {
        type: "radio",
        name: "courtOrProtesting",
        options: courtOrProtesting,
        validation: Yup.string().required("Please select one"),
      },
    ],
    next: (values) => {
      if (values.courtOrProtesting === "Protesting") {
        return "protesting-step-two";
      } else return "court-step-one";
    },
    submit: false,
    stepPath: "/apply/protest",
    stepNumber: "9.1",
  },
  "protesting-step-two": {
    title: "What help do you need?",
    type: "form",
    note: (
      <>
        <p style={{maxWidth: 700}}>
          We need some information to help us consider your request and respond as quickly as possible. Please include the following information if relevant:
        </p>
        <p style={{maxWidth: 700}}>
          <ul>
            <li>Who is organising the protest?</li>
            <li>How many people will be attending the protest?</li>
            <li>What are you protesting?</li>
            <li>Where will the protest be held?</li>
            <li>When will the protest be held?</li>
            <li>Have you taken any actions to seek authorisation of the protest?</li> 
          </ul>
        </p>
        <InformationalPopover description="Our group - Citizens for Climate Action - wants to arrange a protest to demand greater government action on climate change. We plan to hold the protest in Sydney on 28 November. We are looking for advice about what we need to do in order to authorise the protest and our options if the protest isn't authorised. We'd also like some general advice about police powers at protest actions and our rights as protestors." />
      </>
    ),
    components: [
      {
        type: "textarea",
        name: "protestDescription",
        // label: "Briefly describe the help that you need",
        validation: Yup.string()
          .max(1000, "Over character limit")
          .required("Please write some details about the help you need"),
      },
    ],
    next: "protesting-step-three",
    previous: "protesting-step-one",
    submit: false,
    stepNumber: "9.2",
    stepText: "Step 4 of 5",
  },
  "protesting-step-three": {
    title: "Are you protesting as an individual or as part of an organisation?",
    type: "form",
    note: "We will use this information to contact you and to make sure we don’t have a conflict of interest, so we can help you with your concern.",
    components: [
      {
        type: "radio",
        name: "individualOrOrganisation",
        options: indivdualOrganisation,
        validation: Yup.string().required("Please select one"),
      },
      {
        type: "text",
        name: "organisationName",
        label: "Organisation name*",
        condition: { individualOrOrganisation: "organisation" },
        validation: Yup.string().when("individualOrOrganisation", {
          is: "organisation",
          then: Yup.string().required("Please enter Organisation Name"),
        }),
      },
      {
        type: "text",
        name: "contactFirstName",
        label: "Given name*",
        validation: Yup.string().required("Please enter given name"),
      },
      {
        type: "text",
        name: "contactLastName",
        label: "Family name*",
        validation: Yup.string().required("Please enter last name"),
      },
      {
        type: "email",
        name: "contactEmail",
        label: "Email*",
        validation: Yup.string().required("Please enter valid email").email("Please enter valid email"),
      },
      {
        type: "date",
        name: "contactBirthDate",
        label: "Date of birth*",
        validation: Yup.date().required("Please enter date of birth"),
      },
      {
        type: "tel",
        name: "contactNumber",
        label: "Contact number*",
        validation: Yup.string()
          .required("Please enter valid phone number, including area code")
          .matches(
            /^\(?([0-9]{3})\)?([0-9]{3})([0-9]{4})$/,
            "Please enter valid phone number, including area code"
          ),
      },
      {
        type: "address",
        name: "contactAddress",
        label: "Street Address",
      },
      {
        label: "Preferred method of contact",
        type: "select",
        options: methodOfContact,
        name: "preferredContactMethod",
      },
    ],
    next: (values) => {
      if (values.individualOrOrganisation === "individual") {
        return "protesting-step-four";
      } else return "protesting-step-review";
    },
    previous: "protesting-step-two",
    submit: false,
    stepNumber: "9.3",
    stepText: "Step 5 of 5",
  },
  "protesting-step-four": {
    title: "Tell us a bit about you",
    type: "form",
    note: `Select any of the following that apply to you. This information is optional. You do not have to answer these questions. Any answer you give will help us assess your application. Some of our services are provided with the support of government funding, this information will help us report on the services we provide.`,
    components: [
      {
        type: "checkbox",
        name: "tellUsMore",
        options: tellUsMoreOptions,
        label: "Do any of the following apply to you?",
        note: "Please select all that apply",
      },
    ],
    next: "protesting-step-review",
    previous: "protesting-step-three",
    submit: false,
    stepText: "Step 5 of 5",
    stepNumber: "17",
  },
  "protesting-step-review": {
    type: "form-content",
    title: "Review your Application",
    note: "Check that the details you’ve provided are correct, then submit your application. <br/><br/> We want you to know that we will treat your information confidentially in accordance with our legal obligations. By submitting your application, you have requested legal advice. You have not entered into a client agreement with EDO.",
    component: <ProtestReview />,
    next: "/apply/protesting-thanks",
    previous: (values) => {
      if (values.individualOrOrganisation === "individual") {
        return "protesting-step-four";
      } else return "protesting-step-three";
    },
    submit: true,
    stepNumber: "",
    stepPath: "/apply/review",
  },
};
